import React, { useContext } from 'react';

import { songs } from '@/assets/icons';
import { ModalSectionCard } from '@/components/shared/ModalSectionCard';
import { ModalSectionTitle } from '@/components/shared/ModalSectionTitle';
import { SongCard, SongCardSong } from '@/components/shared/SongCard';
import { ChartSectionData, TopTenEntry } from '@/helpers/reportsDataHelpers';
import { useAnalyticsEvent } from '@/providers/AnalyticsProvider';
import { useLayout } from '@/providers/LayoutProvider';
import { SvgIcon } from '@material-ui/core';

import styles from './TopTenSection.module.scss';

type Props = {
	section: ChartSectionData<TopTenEntry>;
};

export const TopTenSection: React.FC<Props> = ({ section }) => {
	const { openSong } = useLayout();
	const fireTopTenOpenSong = useAnalyticsEvent('Reports_Top_Ten_Open_Song');

	if (section.emptyReason !== null) {
		return (
			<ModalSectionCard paddingSize="lg">
				<ModalSectionTitle>Top 10 Songs</ModalSectionTitle>
				<div className={styles['empty']}>
					<SvgIcon
						component={songs}
						className={styles['empty-icon']}
					/>
					<p className={styles['empty-copy']}>
						{section.emptyReason === 'date-filtered'
							? 'No feedback in this period. Try extending the date range.'
							: 'Gather feedback on setlists to see your top songs.'}
					</p>
				</div>
			</ModalSectionCard>
		);
	}

	return (
		<ModalSectionCard paddingSize="lg">
			<ModalSectionTitle>Top 10 Songs</ModalSectionTitle>
			<div className={styles['grid']}>
				{section.data.map((entry) => {
					const song: SongCardSong = {
						name: entry.name,
						artist: entry.artist,
						artworkUrl: entry.artworkUrl,
						recordedKey: null,
						recommendedKey: null,
						analysisStatus: null,
						defaultKey: null,
						rotationStatus: null,
						feedback: {
							overallScore: entry.compositeScore,
							teamSongFeedbackReports: [],
						},
					};
					return (
						<SongCard
							key={entry.teamSongId}
							song={song}
							trend={entry.trend}
							displayTrend
							displayOverallScore
							displayKey={false}
							onClick={() => {
							fireTopTenOpenSong({ id: entry.teamSongId, title: entry.name, artist: entry.artist });
							openSong({ teamSongId: entry.teamSongId });
						}}
						/>
					);
				})}
			</div>
		</ModalSectionCard>
	);
};
